import axios from "axios";
import { environment } from "src/environments/environment";

const base = (environment.baseUrlHub ?? '').toString().replace(/\/+$/, '');
const baseURL = base ? `${base}/api/FleetYarHubNotifier` : '';

export default axios.create({ baseURL });
